import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { Dictionary } from '../../../../types/globals';
import { BrandActionType, brandActions } from './actions';
import { BrandData, BrandsResponseFromApi, BrandsState } from './types';

const defaultBrandState: BrandsState = {
    identifier: '',
    isFetching: false,
    didInvalidate: false,
    brands: [],
    brandEntities: {},
};

const mapBrands = (acc: {}, brand: BrandsResponseFromApi): Dictionary<string> => {
    return {
        ...acc,
        [brand.url_key]: brand.id_catalog_brand,
    };
};

const mapApiBrandsToBellaNaming = (brand: BrandsResponseFromApi): BrandData => {
    return {
        name: brand.name,
        urlKey: brand.url_key,
        catalogBrandId: brand.id_catalog_brand,
    };
};

const brandsReducer = createReducer<BrandsState, BrandActionType>(defaultBrandState)
    .handleAction(brandActions.actions.success, (state, action) => {
        return {
            ...state,
            isFetching: false,
            brands: (action.payload.data.data || []).map(mapApiBrandsToBellaNaming) || [],
            brandEntities: (action.payload.data.data || []).reduce(mapBrands, {}),
        };
    })
    .handleAction(brandActions.actions.failure, defaultErrorHandler)
    .handleAction(brandActions.actions.request, defaultRequestHandler);

export default brandsReducer;
